// Elige un tipo de clasificador: lista si vienen anidados en GET /clasificadores,
// buscador si son demasiados para traerlos todos (REFERENCIA tiene 136 mil).
import React, { useState, useEffect } from "react";
import { apiFetch, inputStyle, COLORS } from "./ui";

function TipoSelector({ token, clasificador, value, onChange, style }) {
  const [texto, setTexto] = useState("");
  const [resultados, setResultados] = useState([]);
  const idClas = clasificador?.id_clasificador;
  const esBuscador = !clasificador?.tipos && clasificador?.total_tipos > 0;
  const buscado = texto.trim();

  useEffect(() => {
    if (!esBuscador || buscado.length < 2) { setResultados([]); return; }
    let vigente = true;
    const espera = setTimeout(() => {
      apiFetch(`/clasificadores/${encodeURIComponent(idClas)}/tipos?buscar=${encodeURIComponent(buscado)}&limite=50`, {}, token)
        .then(res => { if (vigente) setResultados(Array.isArray(res) ? res : []); })
        .catch(() => { if (vigente) setResultados([]); });
    }, 300);
    return () => { vigente = false; clearTimeout(espera); };
  }, [esBuscador, idClas, buscado, token]);

  // Solo un código exacto filtra; mientras se escribe sigue "todos los tipos".
  useEffect(() => {
    if (!esBuscador) return;
    const elegido = resultados.some(t => t.id_tipo === buscado) ? buscado : "";
    if (elegido !== value) onChange(elegido);
  }, [esBuscador, resultados, buscado, value, onChange]);

  if (esBuscador) {
    const listaId = `tipos-${idClas}`;
    return (
      <>
        <input
          list={listaId}
          value={texto}
          onChange={e => setTexto(e.target.value)}
          placeholder={`Buscar entre ${clasificador.total_tipos.toLocaleString("es-CR")} tipos`}
          style={{ ...inputStyle, ...style, border: `1px solid ${buscado && !value ? COLORS.warning : COLORS.border}` }}
        />
        <datalist id={listaId}>
          {resultados.map(t => <option key={t.id_tipo} value={t.id_tipo} label={t.nombre_tipo || t.id_tipo} />)}
        </datalist>
      </>
    );
  }

  if (!clasificador?.tipos?.length) return null;
  return (
    <select value={value} onChange={e => onChange(e.target.value)} style={{ ...inputStyle, ...style }}>
      <option value="">— Todos los tipos —</option>
      {clasificador.tipos.map(t => <option key={t.id_tipo} value={t.id_tipo}>{t.nombre_tipo || t.id_tipo}</option>)}
    </select>
  );
}

export default TipoSelector;
